import calcDiscountPrice from '@anm/helpers/pricing/calcDiscountPrice';
import getMonthlyPriceFromAnnual from '@anm/helpers/pricing/getMonthlyPriceFromAnnual.ts';
import roundPrice from '@anm/helpers/pricing/roundPrice';
import { FC } from 'react';

import { PlanVariant } from '../PlanTitleBlock';

import { BottomPriceBlock, PriceValue, Text } from './Wrapper';

export type PriceProps = {
  price: number;
  variant: PlanVariant;
  isAnnual: boolean;
  discount?: number;
};

const getPrices = (price: number, isAnnual: boolean, discount?: number) => {
  const monthlyPrice = isAnnual ? getMonthlyPriceFromAnnual(price) : price;

  const monthlyDiscountPrice = !discount ? '' : calcDiscountPrice(monthlyPrice, discount);

  const parsedMonthlyPrice = monthlyDiscountPrice || monthlyPrice;
  const annualPrice = parsedMonthlyPrice * 12;

  return {
    annualPrice: roundPrice(annualPrice),
    monthlyPrice: roundPrice(parsedMonthlyPrice),
    fullMonthlyPrice: roundPrice(monthlyPrice)
  };
};

const Price: FC<PriceProps> = ({ price, variant, isAnnual, discount }) => {
  const { monthlyPrice } = getPrices(price, isAnnual, discount);
  return (
    <BottomPriceBlock>
      <PriceValue {...{ variant }}>${monthlyPrice}</PriceValue>
      <Text>/mo</Text>
    </BottomPriceBlock>
  );
};
export default Price;
